import React, { useState, useEffect } from "react";
import { blockCustomer, unblockCustomer, getBlockedCustomers } from "../../utils/api";
import { validatePhone, PHONE_ERROR_MSG } from "../../utils/phoneUtils";
import { Ban, Phone, Trash2, Shield, User } from "lucide-react";
import "./BlockedCustomers.css";

export default function BlockedCustomers({ user, showAlert }) {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [phone, setPhone] = useState("");
  const [staffId, setStaffId] = useState("all");
  const [saving, setSaving] = useState(false);

  const isAdmin = user?.role === "admin";

  const fetchList = async () => {
    try {
      setLoading(true);
      const data = await getBlockedCustomers();
      setList(data);
    } catch (err) {
      console.error("Engellenenler listesi alınamadı:", err);
      showAlert?.({ title: "Hata", message: "Liste alınamadı: " + err.message, variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    if (val.length <= 11) {
      setPhone(val);
    }
  };

  const handleBlock = async (e) => {
    e.preventDefault();
    if (!validatePhone(phone)) {
      showAlert?.({ title: "Geçersiz Numara", message: PHONE_ERROR_MSG, variant: "warning" });
      return;
    }

    try {
      setSaving(true);
      await blockCustomer({ phone, staffId: isAdmin ? staffId : "all" });
      setPhone("");
      showAlert?.({ title: "Başarılı", message: "Numara engellendi.", variant: "success" });
      fetchList();
    } catch (err) {
      showAlert?.({ title: "Hata", message: err.message, variant: "error" });
    } finally {
      setSaving(false);
    }
  };

  const handleUnblock = async (id) => {
    if (!window.confirm("Bu numaradan engeli kaldırmak istediğinize emin misiniz?")) return;
    try {
      await unblockCustomer(id);
      showAlert?.({ title: "Başarılı", message: "Engel kaldırıldı.", variant: "success" });
      fetchList();
    } catch (err) {
      showAlert?.({ title: "Hata", message: err.message, variant: "error" });
    }
  };

  return (
    <div className="blocked-customers-container">
      <div className="admin-section-header">
        <h2 className="section-title" style={{ marginBottom: 0 }}>Engellenen Müşteriler</h2>
      </div>

      <div className="block-form-card">
        <h3>Yeni Numara Engelle</h3>
        <form onSubmit={handleBlock} className="block-form">
          <div className="form-group">
            <label>Telefon Numarası</label>
            <div className="input-with-icon">
              <Phone />
              <input
                type="text"
                placeholder="Örn: 05xxxxxxxxx"
                value={phone}
                onChange={handlePhoneChange}
                required
              />
            </div>
          </div>
          
          {isAdmin && (
            <div className="form-group">
              <label>Engelleme Kapsamı</label>
              <select value={staffId} onChange={(e) => setStaffId(e.target.value)}>
                <option value="all">Tüm İşletme İçin Engelle</option>
                <option value={user.id}>Sadece Benim İçin Engelle</option>
              </select>
            </div>
          )}

          <button type="submit" className="btn-block-action" disabled={saving}>
            <Ban size={18} />
            {saving ? "Engelleniyor..." : "Engelle"}
          </button>
        </form>
      </div>

      <div className="blocked-list-card">
        <h3>Engellenenler Listesi</h3>
        {loading ? (
          <div className="admin-empty">
            <p>Yükleniyor...</p>
          </div>
        ) : list.length === 0 ? (
          <div className="admin-empty">
            <Ban size={48} />
            <p>Henüz engellenen bir numara yok.</p>
          </div>
        ) : (
          <div className="blocked-list">
            {list.map((item) => (
              <div key={item.id} className="blocked-item">
                <div className="blocked-info">
                  <span className="blocked-phone">{item.phone}</span>
                  <div className="blocked-meta">
                    <span className="blocked-date">
                      {new Date(item.createdAt).toLocaleDateString("tr-TR")}
                    </span>
                    <span className="blocked-scope">
                      {item.staffId ? <User size={14} /> : <Shield size={14} />}
                      {item.staffName}
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => handleUnblock(item.id)}
                  className="btn-icon danger"
                  title="Engeli Kaldır"
                >
                  <Trash2 />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
